import { useBoundStore } from "useStore";
import FilterChip from "./FilterChip";

export default function BrandFilterChip() {
  const selectedBrand = useBoundStore(
    (state) => state.campaignManagerSelectedBrand,
  );
  const clearSelectedBrand = useBoundStore(
    (state) => state.clearCampaignManagerSelectedBrand,
  );

  const isEmpty =
    !selectedBrand ||
    (Array.isArray(selectedBrand) && selectedBrand.length === 0);

  if (isEmpty) return null;

  const brandName = Array.isArray(selectedBrand)
    ? selectedBrand[0]
    : selectedBrand;

  return (
    <FilterChip
      icon={true}
      filterName="Brand"
      title={brandName}
      onDelete={() => clearSelectedBrand()}
    />
  );
}
